import {
	GET_CONTENTS,
	GET_CONTENTS_PINNED,
	GET_CONTENTS_TABLET,
	GET_NOTIFICATION,
	GET_PARTNER_PUSHES,
	GET_REACH_DETAIL_BANNER,
	GET_REACH_TABLE,
	getCalendarView,
	getContentShared,
	getContentsList,
	getContentsListPinned,
	getExportMyPeople,
	getNotificationList,
	getPartnerPushList
} from 'api'
import { getReachDataTable, getReachDetailsBanner } from 'api/get/reach/reach'
import {
	AprovalPendingModal,
	Button,
	ContentPerformance,
	ContentTable,
	// SendDirectPush,
	CreateContentItem,
	DropdownFull,
	GroupButton,
	Input,
	Layout,
	SendDirectPush,
	Slide,
	Title,
	Typography
} from 'components'
import ReachModal from 'components/reachModal/reachModal'
import { PaginationContext } from 'context'
import { useSearchDebounce, useToast } from 'hooks'
import {
	DropdownFullItemProps,
	Icons,
	MyContentProps,
	TableResponseContentApproval,
	TypographyTypes
} from 'interfaces'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie'
import { configGenaral } from 'utils'
import {
	allContentTypesData,
	allPartnerContentTypesData,
	allStatusesData,
	allStatusesDataNotification
} from '../lib'

export const Content: React.FC<MyContentProps> = ({
	period,
	setPeriod,
	optionsToRender,
	optionsToRenderTwo,
	periodMyContent,
	setPeriodMyconten,
	optionsToRenderContent,
	setMessageDashboard
}): JSX.Element => {
	const cookies = new Cookies()
	const userId = cookies.get('userId')
	const organizationId = cookies.get('organization_id')
	const numberElement = 10

	const [pageContent, setPageContent] = useState(1)
	const [pageContentSearch, setPageContentSearch] = useState(1)
	const [pageContentPinned, setPageContentPinned] = useState(1)
	const [pagePush, setPagePush] = useState(1)
	const [pagePushSearch, setPagePushSearch] = useState(1)
	const [pagePartnerShared, setPagePartnerShared] = useState(1)
	const [contentOrPartnet, setcontentOrPartnet] = useState(1)
	const [dataSelected, setDataSelected] = useState<number[]>([])
	const { showToast } = useToast()
	const [open, setOpen] = useState(false)
	const [numberAproval, setNumberAproval] = useState<number>(0)
	const [contentType, setContentType] = useState<DropdownFullItemProps>(
		allContentTypesData[0]
	)
	const [partnerContentType, setPartnerContentType] =
		useState<DropdownFullItemProps>(allPartnerContentTypesData[0])
	const [allStatuses, setAllStatuses] = useState<DropdownFullItemProps>(
		allStatusesData[0]
	)
	const [valueItems, setValueItems] = useState(numberElement)
	const [valueItemsPinned, setValueItemsPinned] = useState(numberElement)
	const [valueItemsPush, setValueItemsPush] = useState(numberElement)
	const [valueItemsPartnert, setValueItemsPartnert] = useState(numberElement)
	const [valueItemsPartnerPushes, setValueItemsPartnerPushes] =
		useState(numberElement)
	const [pagePartnerPushes, setPagePartnerPushes] = useState(1)
	const [valueItemsReach, setValueItemsReach] = useState(numberElement)
	const [reachOpenSlide, setReachOpenSlide] = useState(false)
	const [titlesReach, setTitlesReach] = useState<string | null>(null)
	const [resourceId, setResourceId] = useState<number | null>(null)
	const [resourceIdPush, setResourceIdPush] = useState<number | null>(null)
	const [pageTableReach, setPageTableReach] = useState(1)
	const [pageTableReachSearch, setPageTableReachSearch] = useState(1)
	const [openExport, setOpenExport] = useState(false)
	const [openExportSucces, setOpenExportSucces] = useState(false)
	const [exportError, setExportError] = useState<string | null>(null)
	const [searchReach, setSearchReach] = useState('')
	const navigate = useNavigate()
	const { tables, setOrder } = useContext(PaginationContext)

	const { register, setValue, watch } = useForm()

	const watchSearch = watch('search')
	const watchSearchReach = watch('searchReach')

	const { inputSearch, handleChangeDebounce, resetInput } =
		useSearchDebounce(watchSearch)

	const {
		inputSearch: inputSearchReach,
		handleChangeDebounce: handleChangeDebounceReach,
		resetInput: resetInputReach
	} = useSearchDebounce(watchSearchReach)

	const isSearching = inputSearch?.length > 1
	const isSearchingReach = inputSearchReach?.length > 1

	const { data: calendarView } = useQuery({
		queryKey: [organizationId],
		queryFn: () => getCalendarView(organizationId),
		refetchOnWindowFocus: false,
		retry: 0
	})

	const activeCalendarView = calendarView?.active_calendar_view ?? false

	const {
		data: dataPinned,
		isLoading: isLoadingPinned,
		refetch: refetchPinned,
		isRefetching: isRefetchingPinned
	} = useQuery({
		queryKey: [
			GET_CONTENTS_PINNED,
			userId,
			organizationId,
			pageContentPinned,
			allStatuses.value,
			contentType.value,
			inputSearch,
			tables.myContentList.column,
			tables.myContentList.order,
			valueItemsPinned
		],
		queryFn: () =>
			getContentsListPinned(
				organizationId,
				pageContentPinned,
				allStatuses.value || '',
				contentType.value || '',
				'',
				inputSearch,
				valueItemsPinned
			),
		refetchOnWindowFocus: false
	})

	const {
		data,
		isLoading,
		refetch,
		isRefetching: isRefetchingContent
	} = useQuery({
		queryKey: [
			GET_CONTENTS,
			userId,
			organizationId,
			pageContent,
			allStatuses.value,
			contentType.value,
			// allFMStatuses.value,
			inputSearch,
			tables.myContentList.column,
			tables.myContentList.order,
			pageContentSearch,
			valueItems
		],
		queryFn: () =>
			getContentsList(
				organizationId,
				isSearching ? pageContentSearch : pageContent,
				allStatuses.value ?? '',
				contentType.value ?? '',
				inputSearch,
				tables.myContentList.column,
				tables.myContentList.order,
				valueItems
			),
		refetchOnWindowFocus: false
	})

	useEffect(() => {
		setOrder('myContentList', 'last_edit', 'desc')
	}, [])

	const {
		data: dataNotification,
		isLoading: isLoadingNotification,
		refetch: refetchNotification,
		isRefetching
	} = useQuery(
		[
			GET_NOTIFICATION,
			userId,
			organizationId,
			pagePush,
			allStatuses.value,
			inputSearch,
			tables.myContentList.column,
			tables.myContentList.order,
			pagePushSearch,
			valueItemsPush
		],
		() =>
			getNotificationList(
				organizationId,
				isSearching ? pagePushSearch : pagePush,
				allStatuses.value || '',
				'',
				inputSearch,
				tables.myContentList.column || 'last_edit',
				tables.myContentList.order || 'desc',
				valueItemsPush
			)
	)

	useEffect(() => {
		if (dataNotification?.detail && period === 'Direct Pushes') {
			showToast('Error', `${dataNotification.detail}`, 'error')
		}
	}, [dataNotification, period])

	const {
		data: dataPartnerPushes,
		isLoading: isLoadingPartnerPushes,
		isRefetching: isRefetchingPartnerPushes,
		refetch: refetchPartnerPushes
	} = useQuery(
		[
			GET_PARTNER_PUSHES,
			organizationId,
			pagePartnerPushes,
			valueItemsPartnerPushes
		],
		() =>
			getPartnerPushList(
				organizationId,
				pagePartnerPushes,
				valueItemsPartnerPushes
			),
		{
			refetchOnWindowFocus: false,
			enabled: contentOrPartnet === 2
		}
	)

	const {
		data: dataSharedContent,
		isLoading: isLoadingShared,
		refetch: refetchSharedTrue,
		isRefetching: isRefetchingShared
	} = useQuery(
		[
			GET_CONTENTS_TABLET,
			organizationId,
			pagePartnerShared,
			inputSearch,
			partnerContentType.value,
			valueItemsPartnert
		],
		() =>
			getContentShared(organizationId, {
				size: valueItemsPartnert,
				page: pagePartnerShared,
				search: inputSearch.trim(),
				is_approved: true,
				type: partnerContentType.value
			})
	)

	useEffect(() => {
		setPeriodMyconten('My Content')
	}, [])

	useEffect(() => {
		if (!isSearching) {
			setPageContentSearch(1)
			setPagePushSearch(1)
		}
	}, [isSearching])

	const { data: dataReachDetail, isLoading: isLoadingReachDetail } = useQuery({
		queryKey: [
			GET_REACH_DETAIL_BANNER,
			organizationId,
			resourceId,
			resourceIdPush,
			reachOpenSlide
		],
		queryFn: () =>
			getReachDetailsBanner(
				period === 'Direct Pushes' ? resourceIdPush ?? 0 : resourceId ?? 0,
				organizationId,
				period === 'Direct Pushes' ? 'push_notification' : 'content'
			),
		enabled: reachOpenSlide,
		retry: 1
	})

	const { data: dataTableReach, isLoading: isLoadingTableReach } = useQuery({
		queryKey: [
			GET_REACH_TABLE,
			organizationId,
			resourceId,
			resourceIdPush,
			pageTableReach,
			valueItemsReach,
			inputSearchReach,
			reachOpenSlide
		],
		queryFn: () =>
			getReachDataTable(
				organizationId,
				period === 'Direct Pushes' ? resourceIdPush ?? 0 : resourceId ?? 0,
				period === 'Direct Pushes' ? 'push_notification' : 'content',
				isSearchingReach ? pageTableReachSearch : pageTableReach,
				valueItemsReach,
				true,
				inputSearchReach
			),
		refetchOnWindowFocus: false,
		enabled: reachOpenSlide,
		retry: 1
	})

	useEffect(() => {
		if (!isSearchingReach) {
			setPageTableReachSearch(1)
		}
	}, [isSearchingReach])

	const { mutate: mutateGetExport } = useMutation({
		mutationFn: () => {
			const currentResourceId =
				period === 'Direct Pushes' ? resourceIdPush : resourceId
			const currentResourceType =
				period === 'Direct Pushes' ? 'push_notification' : 'content'

			return getExportMyPeople(
				organizationId,
				pageTableReach,
				undefined,
				undefined,
				'asc',
				undefined,
				currentResourceId ?? undefined,
				currentResourceType
			)
		},
		onSuccess: () => {
			setExportError(null)
			setOpenExportSucces(true)
		},
		onError: (error: Error) => {
			setExportError(error.message)
			setOpenExportSucces(true)
		}
	})

	const handleClose = (): void => {
		setSearchReach('')
		resetInputReach?.()
		setPageTableReachSearch(1)
		setPageTableReach(1)
		setValueItemsReach(numberElement)
		setReachOpenSlide(false)
	}

	return (
		<Layout>
			<div className=" 3xl:mx-auto 3xl:my-auto 3xl:w-3/4 mx-auto">
				<div className="flex items-center justify-between ">
					<Title icon={Icons.speakerNotes} title="Content Hub" />
				</div>
				<div className="flex  flex-col-reverse sm:flex-row md:flex-row lg:flex-row gap-5 mt-4 items-center ">
					<Input
						inputFocus
						name="search"
						className="w-full sm:!w-[80%] md:!w-[80%] !p-[unset]  "
						borderFull={false}
						register={register}
						leftIcon={Icons.search}
						inputClassName="p-[unset] py-1 px-2"
						placeholder="Search Content"
						onChangeCustom={handleChangeDebounce}
						rightIcon={Icons.cancel}
						rightClick={() => setValue('search', '')}
						maxLength={configGenaral.maxSearchValue}
					/>
					<GroupButton
						period={periodMyContent}
						numberAproval={numberAproval}
						setPeriod={value => {
							if (value === 'My Content') {
								setcontentOrPartnet(1)
							} else {
								setcontentOrPartnet(2)
								setPeriod('Content Items')
							}

							setPeriodMyconten(value)
						}}
						options={optionsToRenderTwo}
						className="!w-full sm:!w-[52%] md:!w-[33%] lg:!w-[37%] xl:!w-[30%] 2xl:!w-[24%]"
						barBotton
						buttomNormal="min-w-[145px]"
					/>
				</div>
				<div className="flex gap-5 mt-4 md:flex-row sm:flex-col lg:flex-rowflex flex-col lg:flex-row w-full ">
					<ContentPerformance styles="basis-[33%]" />
					<CreateContentItem styles="basis-[33%]" />
					<SendDirectPush
						styles="basis-[33%]"
						setMessageDashboard={setMessageDashboard}
						setPeriod={setPeriod}
					/>
				</div>
				<div
					className="w-full flex items-start justify-between py-3 gap-1 mt-4 md:flex-row sm:flex-row lg:flex-rowflex flex-col lg:flex-row   
				sm:flex-wrap md:flex-nowrap"
				>
					<div className="flex items-center justify-between">
						<GroupButton
							period={period}
							setPeriod={value => {
								resetInput()
								setValue('search', '')
								setPeriod(value)
							}}
							options={
								contentOrPartnet === 1 && periodMyContent === 'My Content'
									? optionsToRender
									: optionsToRenderContent
							}
							big
						/>
					</div>
					{periodMyContent === 'Partner Content' && (
						<Button
							type="button"
							label="Content Approval"
							color="white"
							className="!min-w-[191px]  w-full block sm:block lg:hidden md:hidden "
							onClick={() => setOpen(true)}
						/>
					)}
					<div className="w-full flex justify-center">
						<div
							className={`w-full flex justify-end gap-2  sm:w-full  ${
								period === 'Content Items' &&
								periodMyContent === 'Partner Content'
									? 'w-[100%]  '
									: 'w-full'
							}`}
						>
							{periodMyContent === 'Partner Content' && (
								<Button
									type="button"
									label="Content Approval"
									color="white"
									className="!min-w-[140px] ml-4 hidden  md:block lg:block px-[8px]"
									onClick={() => setOpen(true)}
								/>
							)}
							{period === 'Content Items' ? (
								<>
									<DropdownFull
										rounded
										color="green"
										item={
											contentOrPartnet === 1 ? contentType : partnerContentType
										}
										setItem={
											contentOrPartnet === 1
												? setContentType
												: setPartnerContentType
										}
										list={
											contentOrPartnet === 1
												? allContentTypesData
												: allPartnerContentTypesData
										}
										icon={Icons.arrowDownFull}
										className="min-w-[180px]"
										iconClass="w-[10px] text-blue-primary"
									/>
									<DropdownFull
										rounded
										color="green"
										item={allStatuses}
										setItem={setAllStatuses}
										list={
											period === 'Content Items'
												? allStatusesData
												: allStatusesDataNotification
										}
										icon={Icons.arrowDownFull}
										className="min-w-[138px]"
										iconClass="w-[10px] text-blue-primary"
									/>
									{activeCalendarView && (
										<Button
											type="button"
											label="Calendar View (Beta)"
											color="white"
											className="!min-w-[191px] lg:block !border-blue-primary !border-[1px] px-[10px]"
											contentContainerClassName="gap-1"
											onClick={() => navigate('/content/agenda')}
											iconLeft={Icons.agenda}
										/>
									)}
								</>
							) : (
								activeCalendarView && (
									<Button
										type="button"
										label="Calendar View (Beta)"
										color="white"
										className="!min-w-[191px] lg:block !border-blue-primary !border-[1px]"
										onClick={() => navigate('/content/agenda')}
										iconLeft={Icons.agenda}
									/>
								)
							)}
						</div>
					</div>
				</div>
				{contentOrPartnet === 1 && period === 'Content Items' ? (
					<>
						<div>
							<Typography
								title="Pinned Content"
								type={TypographyTypes.h3}
								fontLeading="16/18"
								className="text-[#323232] mb-2 mt-[20px]"
							/>
							{dataPinned?.items?.length === 0 && (
								<div className="flex items-center justify-center w-full  py-2 px-1 rounded-lg">
									<Typography
										title="You haven't pinned any Content item."
										type={TypographyTypes.h3}
										fontLeading="15/22"
										className="text-[#A3A3A3]"
									/>
								</div>
							)}
							{dataPinned?.items?.length !== 0 && (
								<ContentTable
									data={dataPinned}
									isLoading={isLoadingPinned || isRefetchingPinned}
									page={pageContentPinned}
									setPage={setPageContentPinned}
									dataSelected={dataSelected}
									setDataSelected={setDataSelected}
									refetchPinned={refetchPinned}
									refetch={refetch}
									className="overflow-auto"
									isOrder
									classNameLoading="!max-h-[155px]"
									onShowingItemsChange={setValueItemsPinned}
									onShowingItems={valueItemsPinned}
									setReachOpenSlide={(
										openSlide: boolean,
										id: number,
										title: string
									) => {
										setReachOpenSlide(openSlide)
										setResourceId(id)
										setTitlesReach(title)
									}}
								/>
							)}
						</div>

						<div className="mt-1">
							<Typography
								title="All Content"
								type={TypographyTypes.h3}
								fontLeading="16/18"
								className="text-[#323232] mb-2"
							/>
							<ContentTable
								data={data}
								isLoading={isLoading || isRefetchingContent}
								page={isSearching ? pageContentSearch : pageContent}
								setPage={isSearching ? setPageContentSearch : setPageContent}
								dataSelected={dataSelected}
								setDataSelected={setDataSelected}
								refetch={refetch}
								refetchPinned={refetchPinned}
								className="overflow-auto"
								onShowingItemsChange={setValueItems}
								onShowingItems={valueItems}
								refetchOtherTable={refetchNotification}
								setReachOpenSlide={(
									openSlide: boolean,
									id: number,
									title: string
								) => {
									setReachOpenSlide(openSlide)
									setResourceId(id)
									setTitlesReach(title)
								}}
							/>
						</div>
					</>
				) : contentOrPartnet === 1 && period === 'Direct Pushes' ? (
					<ContentTable
						data={dataNotification}
						isLoading={isLoadingNotification || isRefetching}
						page={isSearching ? pagePushSearch : pagePush}
						setPage={isSearching ? setPagePushSearch : setPagePush}
						dataSelected={dataSelected}
						setDataSelected={setDataSelected}
						refetch={refetchNotification}
						dataNotification={period === 'Direct Pushes'}
						className="overflow-auto"
						onShowingItemsChange={setValueItemsPush}
						onShowingItems={valueItemsPush}
						setReachOpenSlide={(
							openSlide: boolean,
							id: number,
							title: string
						) => {
							setReachOpenSlide(openSlide)
							setResourceIdPush(id)
							setTitlesReach(title)
						}}
					/>
				) : (
					contentOrPartnet === 2 &&
					period === 'Content Items' && (
						<ContentTable
							data={dataSharedContent}
							isLoading={isLoadingShared || isRefetchingShared}
							page={pagePartnerShared}
							setPage={setPagePartnerShared}
							dataSelected={dataSelected}
							setDataSelected={setDataSelected}
							refetch={refetchSharedTrue}
							contentOrPartnet={contentOrPartnet}
							className="overflow-auto"
							onShowingItemsChange={setValueItemsPartnert}
							onShowingItems={valueItemsPartnert}
							isReach={false}
						/>
					)
				)}
				{contentOrPartnet === 2 && period === 'Partner Pushes' && (
					<>
						{dataPartnerPushes?.items?.length === 0 && (
							<div className="flex items-center justify-center w-full py-6">
								<Typography
									title="No partner pushes found."
									type={TypographyTypes.h3}
									fontLeading="15/22"
									className="text-[#A3A3A3]"
								/>
							</div>
						)}
						{(dataPartnerPushes?.items?.length ?? 0) > 0 && (
							<ContentTable
								data={dataPartnerPushes}
								isLoading={isLoadingPartnerPushes || isRefetchingPartnerPushes}
								page={pagePartnerPushes}
								setPage={setPagePartnerPushes}
								dataSelected={dataSelected}
								setDataSelected={setDataSelected}
								refetch={refetchPartnerPushes}
								contentOrPartnet={contentOrPartnet}
								className="overflow-auto"
								onShowingItemsChange={setValueItemsPartnerPushes}
								onShowingItems={valueItemsPartnerPushes}
								isReach={false}
								dataNotification
							/>
						)}
					</>
				)}

				<AprovalPendingModal
					setOpen={setOpen}
					open={open}
					data={data as TableResponseContentApproval}
					setNumberAproval={setNumberAproval}
					refetchSharedTrue={refetchSharedTrue}
				/>
				<Slide
					title="Reach Details"
					titleHelper="If you set a Delivery Radius, this content item will be delivered when your audience enters the Radius."
					open={reachOpenSlide}
					setOpen={handleClose}
					classNameTitle="!text-black !font-bold"
					className="!max-w-[58.8rem]"
				>
					<ReachModal
						setPageSearch={setPageTableReachSearch}
						resetInput={resetInputReach}
						handleChangeDebounce={handleChangeDebounceReach}
						register={register}
						data={dataTableReach}
						page={isSearchingReach ? pageTableReachSearch : pageTableReach}
						setPage={
							isSearchingReach ? setPageTableReachSearch : setPageTableReach
						}
						isLoadingReachDetail={isLoadingReachDetail}
						open={reachOpenSlide}
						setOpen={setReachOpenSlide}
						titlesReach={titlesReach ?? ''}
						dataReachDetail={dataReachDetail}
						isLoadingReachTable={isLoadingTableReach}
						onShowingItems={valueItemsReach}
						onShowingItemsChange={setValueItemsReach}
						setOpenExport={setOpenExport}
						openExport={openExport}
						setOpenExportSucces={setOpenExportSucces}
						openExportSucces={openExportSucces}
						mutateExport={mutateGetExport}
						setSearch={setSearchReach}
						search={searchReach}
						reachModalTitle={
							period === 'Direct Pushes'
								? 'Push Notification Title:'
								: 'Content Item Title:'
						}
						exportErrorMessage={exportError}
					/>
				</Slide>
			</div>
		</Layout>
	)
}
